import type { ServiceConfigJSON } from '@takeshape/schema';
import type { BranchQueryArgs } from 'app/branches/types';
import type { SetRequired } from 'type-fest';
import { mutateAdmin, queryAdmin } from '../graphql-client.js';
import type { ServiceHealth } from './types.js';

export const ENCRYPT_SERVICE_AUTH_MUTATION = /* GraphQL */ `
  mutation ($input: EncryptServiceAuthInput!) {
    data: encryptServiceAuth(input: $input)
  }
`;

export const BOOTSTRAP_SHOPIFY_MUTATION = /* GraphQL */ `
  mutation ($serviceId: ID!, $serviceObjectType: ShopifyObjectType!, $idFieldName: String!, $shapeName: String!) {
    result: bootstrapShopify(serviceId: $serviceId, serviceObjectType: $serviceObjectType, idFieldName: $idFieldName, shapeName: $shapeName) {
      totalCreated
    }
  }
`;

export const encryptServiceAuth = mutateAdmin(ENCRYPT_SERVICE_AUTH_MUTATION, (input) => ({ input }));
export const bootstrapShopify = mutateAdmin(BOOTSTRAP_SHOPIFY_MUTATION);

export type GetServiceHealthData = {
  serviceHealth: ServiceHealth[];
};

export const GET_SERVICE_HEALTH_QUERY = /* GraphQL */ `
  query (
    $projectId: String!
    $environment: TSSchemaBranchEnvironment!
    $branchName: String
    $userId: String
    $onlyCurrent: Boolean
  ) {
    serviceHealth: getServiceHealth(
      projectId: $projectId
      environment: $environment
      branchName: $branchName
      userId: $userId
      onlyCurrent: $onlyCurrent
    ) {
      check
      serviceId
      timestamp
      reason
      reasonCode
      status
    }
  }
`;

export async function getServiceHealth(
  variables: BranchQueryArgs & { onlyCurrent?: boolean }
): Promise<GetServiceHealthData> {
  return queryAdmin<GetServiceHealthData>(GET_SERVICE_HEALTH_QUERY)(variables);
}

export type CheckServiceHealthData = {
  serviceHealth: ServiceHealth;
};

export const CHECK_SERVICE_HEALTH_MUTATION = /* GraphQL */ `
  mutation ($input: CheckServiceHealthInput!) {
    serviceHealth: checkServiceHealth(input: $input) {
      check
      serviceId
      timestamp
      reason
      reasonCode
      status
      response
    }
  }
`;

export type CheckServiceHealthMutationInput = BranchQueryArgs &
  SetRequired<Partial<ServiceConfigJSON>, 'id'> & {
    writeLog?: boolean;
  };

export async function checkServiceHealthMutation(variables: {
  input: CheckServiceHealthMutationInput;
}): Promise<CheckServiceHealthData> {
  return mutateAdmin<CheckServiceHealthData>(CHECK_SERVICE_HEALTH_MUTATION)(variables);
}
